import React, {ReactNode, useState} from 'react'
import {BlockSpacer, GridContainer, GridItem} from '../../../styledComponents/ResponsiveConvenience'
import {DisplayItemLabelDiv} from '../../../styledComponents/DisplayItem'
import {Colors, FontWeights} from '../../../styledComponents/Constants'
import styled from 'styled-components'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Collapse} from '@mui/material'
import {ExpandButton} from './CommonStyle'

export type ReservationDetailItemType = 'texts' | 'component'

interface Props {
    type: ReservationDetailItemType
}

interface IncludeComponentProps extends Props {
    type: 'component'
    title: string
    component: ReactNode
    children?: never
    collapse?: boolean
    collapsedText?: string
}

interface IncludeTextOnlyProps extends Props {
    type: 'texts'
    title: string
    texts: string[]
    children?: never
}

const ReservationDetailItem: React.FC<IncludeComponentProps | IncludeTextOnlyProps> = props => {

    const renderTexts = (title: string, texts: string[]): ReactNode => {
        return <> {
            texts.map((item, i) =>
                <GridContainer key={i}>
                    {
                        (i === 0)
                            ? <GridItem over={3}><DisplayItemLabelDiv>{title}</DisplayItemLabelDiv></GridItem>
                            : <GridItem over={3}/>
                    }
                    <GridItem over={9}>
                        <RowFlexContainer><TextContents>{item}</TextContents></RowFlexContainer>
                    </GridItem>
                </GridContainer>,
            )
        } </>
    }

    const RenderComponent = (
        title: string, component: React.ReactNode, collapsedText?: string,
    ) => {
        const [open, setOpen] = useState(collapsedText === undefined)
        return <GridContainer>
            <GridItem over={3}>
                <DisplayItemLabelDiv>{title}</DisplayItemLabelDiv>
            </GridItem>
            {
                <GridItem over={9}> {
                    collapsedText &&
                    <CenteringRowFlexContainer onClick={() => setOpen(!open)}>
                        <TextContents>{collapsedText}</TextContents>
                        <BlockSpacer width={'10px'}/>
                        <ExpandButton open={open}/>
                    </CenteringRowFlexContainer>}
                </GridItem>
            }

            {
                <GridItem over={12}>
                    <Collapse in={open}>
                        {collapsedText && <BlockSpacer height={'20px'}/>}
                        {component}
                    </Collapse>
                </GridItem>
            }
        </GridContainer>
    }

    return <ItemDiv>
        {
            props.type === 'texts' &&
            renderTexts(props.title, props.texts)
        }
        {
            props.type === 'component' &&
            RenderComponent(
                props.title,
                props.component,
                props.collapsedText,
            )
        }
    </ItemDiv>
}

ReservationDetailItem.displayName = 'ReservationDetailItem'
export default ReservationDetailItem

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
`

const CenteringRowFlexContainer = styled(RowFlexContainer)`
  align-content: center;
`
